import MetaInfoListItem from "components/MetaInfoList/Item";
import { VCS_PROVIDERS_ICONS } from "constants/providerIcons";
import { Maybe, VcsIntegration, VcsProvider } from "types/generated";
import { getRepoUrl } from "utils/spaceliftRepo";

type MetaInfoSpaceliftRepoProps = {
  vcsIntegration: Maybe<Pick<VcsIntegration, "id" | "name">>;
};

const MetaInfoSpaceliftRepo = ({ vcsIntegration }: MetaInfoSpaceliftRepoProps) => {
  if (!vcsIntegration) return null;

  const repoUrl = getRepoUrl(vcsIntegration.id);

  return (
    <MetaInfoListItem
      to={repoUrl}
      linkText={vcsIntegration.name}
      icon={VCS_PROVIDERS_ICONS[VcsProvider.Spacelift]}
      target="_blank"
    />
  );
};

export default MetaInfoSpaceliftRepo;
